export default __webpack_public_path__ + "static/badge-do-2-bold-light-d0692ebfeff624da9050d7e2718707959468a28f3f39bd7eb1208093bd952f83.png";